/**
 * Custom Variant Price Calculator
 * Handles dynamic price updates and price difference displays
 */

(function () {
  'use strict';

  // ==============================
  // Professional Assembly Postcode Modal - Config
  // ==============================

  // List of allowed postcodes for Professional Assembly
  const ALLOWED_POSTCODES = [
    'AL1', 'AL2', 'AL3', 'AL4', 'AL5', 'AL6', 'AL7', 'AL8', 'AL9', 'AL10', 'AL11',
    'CM16', 'CM17', 'CM18', 'CM19', 'CM20', 'CM21', 'CM22', 'CM23', 'CM24',
    'E1', 'E2', 'E8',
    'EC1A', 'EC1M', 'EC1N', 'EC1P', 'EC1R', 'EC1V', 'EC1Y',
    'EC2A', 'EC2M', 'EC2N', 'EC2P', 'EC2R', 'EC2V', 'EC2Y',
    'EC3A', 'EC3M', 'EC3N', 'EC3P', 'EC3R', 'EC3V',
    'EC4A', 'EC4M', 'EC4N', 'EC4P', 'EC4R', 'EC4V', 'EC4Y',
    'EN1', 'EN2', 'EN3', 'EN4', 'EN5', 'EN6', 'EN7', 'EN8', 'EN9', 'EN10', 'EN11',
    'HA0', 'HA1', 'HA2', 'HA3', 'HA4', 'HA5', 'HA6', 'HA7', 'HA8', 'HA9',
    'HP1', 'HP2', 'HP3', 'HP4', 'HP5', 'HP6', 'HP7', 'HP8', 'HP9', 'HP10',
    'HP11', 'HP12', 'HP13', 'HP14', 'HP15', 'HP16', 'HP17', 'HP18', 'HP19', 'HP20',
    'HP21', 'HP22', 'HP23', 'HP27',
    'IG1', 'IG2', 'IG3', 'IG4', 'IG5', 'IG6',
    'LU1', 'LU2', 'LU3', 'LU4', 'LU5', 'LU6', 'LU7', 'LU95',
    'MK1', 'MK2', 'MK3', 'MK4', 'MK5', 'MK6', 'MK7', 'MK8', 'MK9', 'MK10',
    'MK11', 'MK12', 'MK13', 'MK14', 'MK15', 'MK16', 'MK77',
    'N1', 'N1P', 'N2', 'N3', 'N4', 'N5', 'N6', 'N7', 'N8', 'N9', 'N10',
    'N11', 'N12', 'N13', 'N14', 'N15', 'N16', 'N17', 'N18', 'N19', 'N20', 'N21', 'N22',
    'NW1', 'NW1W', 'NW2', 'NW3', 'NW4', 'NW5', 'NW6', 'NW7', 'NW8', 'NW9', 'NW10', 'NW11', 'NW26',
    'SE1',
    'SG1', 'SG2', 'SG3', 'SG4', 'SG5', 'SG6', 'SG7', 'SG8', 'SG9', 'SG10',
    'SG11', 'SG12', 'SG13', 'SG14', 'SG15', 'SG19',
    'SL0', 'SL1', 'SL2', 'SL3',
    'UB1', 'UB2', 'UB3', 'UB4', 'UB5', 'UB6', 'UB7', 'UB8', 'UB9', 'UB10', 'UB11', 'UB18',
    'W1A', 'W1B', 'W1C', 'W1D', 'W1E', 'W1F', 'W1G', 'W1H', 'W1J', 'W1K', 'W1M', 'W1S', 'W1T', 'W1U', 'W1W',
    'W2', 'W3', 'W5', 'W6', 'W7', 'W8', 'W9', 'W11', 'W12', 'W13',
    'WC1A', 'WC1B', 'WC1E', 'WC1H', 'WC1N', 'WC1R', 'WC1V', 'WC1X',
    'WC2A', 'WC2B', 'WC2E', 'WC2H', 'WC2N', 'WC2R',
    'WD3', 'WD4', 'WD5', 'WD6', 'WD7', 'WD17', 'WD18', 'WD19', 'WD23', 'WD24', 'WD25', 'WD99'
  ];

  let currentAssemblyContainer = null;

  // Format price in currency
  function formatPrice(priceInCents) {
    return '\u00A3' + (priceInCents / 100).toFixed(2);
  }

  // Format price difference
  function formatPriceDifference(difference) {
    if (difference === 0) {
      return formatPrice(0);
    }
    const prefix = difference > 0 ? '+' : '-';
    const absoluteValue = Math.abs(difference);
    return prefix + '\u00A3' + (absoluteValue / 100).toFixed(2);
  }

  // Get product variants data
  function getProductVariantsData() {
    const dataScript = document.getElementById('product-variants-data');
    if (dataScript) {
      try {
        return JSON.parse(dataScript.textContent);
      } catch (e) {
        console.error('Failed to parse product variants data:', e);
      }
    }
    return { variants: [] };
  }

  // Normalize option value for comparison (handles inch symbols and other special chars)
  function normalizeOptionValue(value) {
    if (!value) return value;
    // Remove trailing inch symbol and any quotes
    return value.replace(/["']+$/g, '').trim();
  }

  // Find matching variant based on selected options
  function findMatchingVariant(selectedOptions) {
    const variantsData = getProductVariantsData();

    // Count how many options we're searching for
    const searchOptionCount = Object.keys(selectedOptions).filter(key => key.startsWith('option')).length;

    return variantsData.variants.find(variant => {
      // Check if all selected options match this variant
      let matchCount = 0;
      for (let i = 1; i <= 3; i++) {
        const optionKey = 'option' + i;
        if (selectedOptions[optionKey]) {
          // Normalize both values before comparison
          const normalizedSelected = normalizeOptionValue(selectedOptions[optionKey]);
          const normalizedVariant = normalizeOptionValue(variant[optionKey]);

          if (normalizedVariant === normalizedSelected) {
            matchCount++;
          } else {
            return false;
          }
        }
      }
      // Only return true if we matched all the options we were searching for
      return matchCount === searchOptionCount && matchCount > 0;
    });
  }

  // Update tab labels and main product title with selected option values
  function updateTabLabels() {
    const variantTabs = document.querySelectorAll('.variant-tab');
    const tabListItems = document.querySelectorAll('.variant-items-list-custom li');

    variantTabs.forEach((tab) => {
      const tabId = tab.getAttribute('id');
      const isProductOptionTab = tabId && tabId.startsWith('tab-option-') && tabId !== 'tab-option-color-1';
      const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');

      // Find the corresponding tab list item
      const tabListItem = Array.from(tabListItems).find(item =>
        item.getAttribute('data-id') === tabId
      );

      if (selectedInput && tabListItem) {
        const tabLabel = tabListItem.querySelector('p');

        if (tabLabel) {
          if (isProductOptionTab) {
            // For product option tabs, get the option value
            const optionValue = selectedInput.getAttribute('data-option-value');
            if (optionValue) {
              tabLabel.textContent = optionValue;
            }
          } else {
            // For metafield/fabric tabs, get the variant title from the h4 element
            const variantTitle = selectedInput.closest('.custom-variant-item').querySelector('h4');
            if (variantTitle) {
              tabLabel.textContent = variantTitle.textContent;
            }
          }
        }
      }
    });

    // NEW: Update the main product H1 title dynamically with the Fabric selection
    const selectedFabric = document.querySelector('input[name="variant-fabric-color"]:checked');
    if (selectedFabric) {
      const colorName = selectedFabric.getAttribute('data-color-name');
      const titleSpans = document.querySelectorAll('.dynamic-title-color');
      
      titleSpans.forEach(span => {
        if (colorName) {
          span.textContent = ' - ' + colorName;
        }
      });
    }
  }

  // Update all variant prices based on selected variant
  function updateVariantPrices() {
    const variantTabs = document.querySelectorAll('.variant-tab');
    let totalPrice = 0;

    // 1. Collect selected option values from main product option tabs
    const selectedOptions = {};
    const productOptionTabs = Array.from(variantTabs).filter(tab => {
      const tabId = tab.getAttribute('id');
      return tabId && tabId.startsWith('tab-option-') && tabId !== 'tab-option-color-1';
    });

    productOptionTabs.forEach((tab) => {
      const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');
      if (selectedInput) {
        const optionValue = selectedInput.getAttribute('data-option-value');
        const optionPosition = parseInt(selectedInput.getAttribute('data-option-position'));
        if (optionValue && optionPosition) {
          selectedOptions['option' + optionPosition] = optionValue;
        }
      }
    });

    // 2. Add Base Product Price
    const matchingVariant = findMatchingVariant(selectedOptions);
    if (matchingVariant) {
      totalPrice = matchingVariant.price;
    }

    // 3. Add standard Metafield Add-on prices
    variantTabs.forEach((tab) => {
      const tabId = tab.getAttribute('id');
      const isProductOptionTab = tabId && tabId.startsWith('tab-option-') && tabId !== 'tab-option-color-1';

      if (!isProductOptionTab && tabId !== 'tab-option-color-1') {
        const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');
        if (selectedInput) {
          const price = parseInt(selectedInput.getAttribute('data-price')) || 0;
          totalPrice += price;
        }
      }
    });

    // 4. EXPLICITLY Add Fabric Swatch Price
    const selectedFabric = document.querySelector('input[name="variant-fabric-color"]:checked');
    if (selectedFabric) {
      const fabricPrice = parseInt(selectedFabric.getAttribute('data-price')) || 0;
      totalPrice += fabricPrice;
    }

    // 5. NEW: Add Mattress Price to Total
    const selectedMattress = document.querySelector('.mattress-add-on.selected input');
    if (selectedMattress && selectedMattress.closest('.mattress-add-on.selected').style.display !== 'none') {
      const mattressPrice = parseInt(selectedMattress.getAttribute('data-price')) || 0;
      totalPrice += mattressPrice;
    }

    // 6. NEW: Add Assembly Price to Total (£102.00)
    const assemblyContainer = document.querySelector('.add-cart-main-assembly');
    if (assemblyContainer && assemblyContainer.classList.contains('assembly-added')) {
      totalPrice += 10200; 
    }

    // Update main product price display
    const mainPriceElement = document.querySelector('.custom-variant-price-value');
    if (mainPriceElement) {
      mainPriceElement.textContent = formatPrice(totalPrice);
    }

    updatePriceDifferences();
    updateTabLabels();
  }

  // Update price differences for all variants
  function updatePriceDifferences() {
    const variantTabs = document.querySelectorAll('.variant-tab');

    // Get currently selected options to find the base price
    const selectedOptions = {};
    const productOptionTabs = Array.from(variantTabs).filter(tab => {
      const tabId = tab.getAttribute('id');
      // Ensure we exclude the color tab from main product logic
      return tabId && tabId.startsWith('tab-option-') && tabId !== 'tab-option-color-1';
    });

    productOptionTabs.forEach((tab) => {
      const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');
      if (selectedInput) {
        const optionValue = selectedInput.getAttribute('data-option-value');
        const optionPosition = parseInt(selectedInput.getAttribute('data-option-position'));
        if (optionValue && optionPosition) {
          selectedOptions['option' + optionPosition] = optionValue;
        }
      }
    });

    const currentVariant = findMatchingVariant(selectedOptions);
    const currentPrice = currentVariant ? currentVariant.price : 0;

    variantTabs.forEach((tab) => {
      const inputs = tab.querySelectorAll('.custom-variant-item input[type="radio"]');
      const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');

      const tabId = tab.getAttribute('id');
      const isProductOptionTab = tabId && tabId.startsWith('tab-option-') && tabId !== 'tab-option-color-1';

      if (!selectedInput) {
        // If no selection in this tab and it's a metafield/fabric tab, show prices as additions
        if (!isProductOptionTab) {
          inputs.forEach((input) => {
            const variantPrice = parseInt(input.getAttribute('data-price')) || 0;
            const priceDisplay = input.closest('.custom-variant-item').querySelector('.variant-price-display');

            if (priceDisplay) {
              if (variantPrice > 0) {
                priceDisplay.textContent = '+' + formatPrice(variantPrice);
              } else {
                priceDisplay.textContent = formatPrice(variantPrice);
              }
            }
          });
        }
        return;
      }

      // For product option tabs (Size, Base Type), calculate difference
      if (isProductOptionTab) {
        inputs.forEach((input) => {
          const optionValue = input.getAttribute('data-option-value');
          const optionPosition = parseInt(input.getAttribute('data-option-position'));

          const hypotheticalOptions = { ...selectedOptions };
          if (optionValue && optionPosition) {
            hypotheticalOptions['option' + optionPosition] = optionValue;
          }

          const hypotheticalVariant = findMatchingVariant(hypotheticalOptions);
          const hypotheticalPrice = hypotheticalVariant ? hypotheticalVariant.price : 0;

          const priceDifference = hypotheticalPrice - currentPrice;
          const priceDisplay = input.closest('.custom-variant-item').querySelector('.variant-price-display');
          const variantItem = input.closest('.custom-variant-item');

          if (!hypotheticalVariant) {
            input.disabled = true;
            variantItem.classList.add('unavailable');
            if (priceDisplay) priceDisplay.textContent = '';
          } else {
            input.disabled = false;
            variantItem.classList.remove('unavailable');

            if (priceDisplay) {
              if (input.checked) {
                priceDisplay.textContent = formatPrice(hypotheticalPrice);
              } else {
                priceDisplay.textContent = formatPriceDifference(priceDifference);
              }
            }
          }
        });
      } else {
        // For metafield & Fabric Swatch tabs, display as straight additions
        inputs.forEach((input) => {
          const variantPrice = parseInt(input.getAttribute('data-price')) || 0;
          const priceDisplay = input.closest('.custom-variant-item').querySelector('.variant-price-display');

          if (priceDisplay) {
            if (variantPrice > 0) {
              priceDisplay.textContent = '+' + formatPrice(variantPrice);
            } else {
              priceDisplay.textContent = formatPrice(variantPrice);
            }
          }
        });
      }
    });
  }
  

  // Handle tab switching
  function handleTabClick(event) {
    const clickedTab = event.currentTarget;
    const targetId = clickedTab.getAttribute('data-id');

    // Remove active class from all tabs
    document.querySelectorAll('.variant-items-list-custom li').forEach((tab) => {
      tab.classList.remove('active');
    });

    // Add active class to clicked tab
    clickedTab.classList.add('active');

    // Hide all tab contents
    document.querySelectorAll('.variant-tab').forEach((content) => {
      content.classList.remove('active');
    });

    // Show target tab content
    const targetContent = document.getElementById(targetId);
    if (targetContent) {
      targetContent.classList.add('active');
    }
  }

  // Handle variant selection
  function handleVariantChange(event) {
    const input = event.target;

    if (input.type === 'radio' && input.closest('.custom-variant-item')) {
      // Update prices when variant is selected
      updateVariantPrices();
      // Clear any error state when user makes a selection
      clearTabError(input.closest('.variant-tab'));
    }
  }

  // Clear error state from a tab
  function clearTabError(tab) {
    if (!tab) return;
    const tabId = tab.getAttribute('id');
    const tabListItem = document.querySelector(`.variant-items-list-custom li[data-id="${tabId}"]`);
    if (tabListItem) {
      tabListItem.classList.remove('error');
    }
    // Also remove error message if exists
    const errorMsg = document.querySelector('.custom-variant-error');
    if (errorMsg) {
      errorMsg.remove();
    }
  }

  // Validate all metafield tabs have a selection
  function validateMetafieldSelections() {
    const variantTabs = document.querySelectorAll('.variant-tab');
    const errors = [];

    variantTabs.forEach((tab) => {
      const tabId = tab.getAttribute('id');
      const isProductOptionTab = tabId && tabId.startsWith('tab-option-');

      // Only validate metafield tabs
      if (!isProductOptionTab) {
        const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');
        const tabListItem = document.querySelector(`.variant-items-list-custom li[data-id="${tabId}"]`);
        const tabName = tabListItem ? tabListItem.querySelector('h5').textContent : 'Option';

        if (!selectedInput) {
          errors.push({
            tabId: tabId,
            tabName: tabName,
            tabListItem: tabListItem
          });
        }
      }
    });

    return errors;
  }

  // Show error message
  function showError(message) {
    // Remove existing error message
    const existingError = document.querySelector('.custom-variant-error');
    if (existingError) {
      existingError.remove();
    }

    // Create error element
    const errorDiv = document.createElement('div');
    errorDiv.className = 'custom-variant-error';
    errorDiv.textContent = message;

    // Insert before add to cart button
    const addToCartBtn = document.querySelector('.variant-cart-add-btn');
    if (addToCartBtn) {
      addToCartBtn.parentNode.insertBefore(errorDiv, addToCartBtn);
    }
  }

  // Get selected main product variant
  function getSelectedMainVariant() {
    const variantTabs = document.querySelectorAll('.variant-tab');
    const selectedOptions = {};

    // Check if product has real variants (product option tabs)
    const productOptionTabs = Array.from(variantTabs).filter(tab => {
      const tabId = tab.getAttribute('id');
      return tabId && tabId.startsWith('tab-option-');
    });

    if (productOptionTabs.length > 0) {
      // Collect selected options from product variant tabs
      productOptionTabs.forEach((tab) => {
        const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');
        if (selectedInput) {
          const optionValue = selectedInput.getAttribute('data-option-value');
          const optionPosition = parseInt(selectedInput.getAttribute('data-option-position'));
          if (optionValue && optionPosition) {
            selectedOptions['option' + optionPosition] = optionValue;
          }
        }
      });

      // Find matching variant
      const matchingVariant = findMatchingVariant(selectedOptions);
      return matchingVariant;
    } else {
      // Single variant product - return first variant
      const variantsData = getProductVariantsData();
      return variantsData.variants[0] || null;
    }
  }

  // Get all selected metafield variants
  function getSelectedMetafieldVariants() {
    const variantTabs = document.querySelectorAll('.variant-tab');
    const metafieldVariants = [];

    // 1. Grab standard Metafield Add-ons
    variantTabs.forEach((tab) => {
      const tabId = tab.getAttribute('id');
      const isProductOptionTab = tabId && tabId.startsWith('tab-option-') && tabId !== 'tab-option-color-1';

      if (!isProductOptionTab && tabId !== 'tab-option-color-1') {
        const selectedInput = tab.querySelector('.custom-variant-item input[type="radio"]:checked');
        if (selectedInput) {
          const variantId = selectedInput.getAttribute('data-variant-id');
          const variantTitle = selectedInput.closest('.custom-variant-item').querySelector('h4');
          const tabListItem = document.querySelector(`.variant-items-list-custom li[data-id="${tabId}"]`);
          const tabName = tabListItem ? tabListItem.querySelector('h5').textContent : 'Option';

          metafieldVariants.push({
            id: parseInt(variantId),
            title: variantTitle ? variantTitle.textContent : '',
            tabName: tabName
          });
        }
      }
    });

    // 2. EXPLICITLY Grab Fabric Swatch Variant for the Cart
    const selectedFabric = document.querySelector('input[name="variant-fabric-color"]:checked');
    if (selectedFabric) {
      const variantId = selectedFabric.getAttribute('data-variant-id');
      const colorName = selectedFabric.getAttribute('data-color-name');
      
      metafieldVariants.push({
        id: parseInt(variantId),
        title: colorName,
        tabName: 'Fabric Color'
      });
    }

    return metafieldVariants;
  }

  // Generate unique bundle ID
  function generateBundleId() {
    return 'bundle_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
  }

  // Get main product title
  function getMainProductTitle() {
    const titleElement = document.querySelector('.product__title h1') ||
      document.querySelector('.product-single__title') ||
      document.querySelector('[data-product-title]') ||
      document.querySelector('h1.title');
    return titleElement ? titleElement.textContent.trim() : 'Main Product';
  }

  // Build properties for main product (shows selected metafield options)
  function buildMainProductProperties(metafieldVariants, bundleId) {
    const properties = {};

    // Add bundle ID (hidden property - starts with underscore)
    properties['_bundle_id'] = bundleId;

    // Add an underscore '_' before the tabName to hide our manual properties,
    // allowing the theme's native bundle script to handle the visual display without duplicates.
    metafieldVariants.forEach((variant) => {
      properties['_' + variant.tabName] = variant.title;
    });

    return properties;
  }

  // Build properties for metafield/child products
  function buildChildProductProperties(bundleId, mainProductTitle) {
    return {
      '_bundle_id': bundleId,
      '_parent_product': mainProductTitle
    };
  }

  // Add items to cart using Shopify AJAX API
  async function addToCart(items) {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ items: items })
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.description || 'Failed to add to cart');
      }

      return await response.json();
    } catch (error) {
      throw error;
    }
  }

  // Handle Add to Cart click
  async function handleAddToCart(event) {
    event.preventDefault();

    const addToCartBtn = event.target;

    // Validate metafield selections
    const validationErrors = validateMetafieldSelections();

    if (validationErrors.length > 0) {
      // Highlight tabs with errors
      validationErrors.forEach((error) => {
        if (error.tabListItem) {
          error.tabListItem.classList.add('error');
        }
      });

      // Show error message
      const missingOptions = validationErrors.map(e => e.tabName).join(', ');
      showError(`Please select an option for: ${missingOptions}`);

      // Scroll to first error tab and activate it
      if (validationErrors[0].tabListItem) {
        validationErrors[0].tabListItem.click();
        validationErrors[0].tabListItem.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }

      return;
    }

    // Get main product variant
    const mainVariant = getSelectedMainVariant();

    if (!mainVariant) {
      showError('Please select a valid product variant');
      return;
    }

    // Get metafield variants
    const metafieldVariants = getSelectedMetafieldVariants();

    // Generate unique bundle ID to link all items
    const bundleId = generateBundleId();
    const mainProductTitle = getMainProductTitle();

    // Build properties for main product
    const mainProductProperties = buildMainProductProperties(metafieldVariants, bundleId);



    // Prepare cart items
    const cartItems = [];



    // Add main product with properties
    cartItems.push({
      id: mainVariant.id,
      quantity: 1,
      properties: mainProductProperties
    });

    // Add each metafield variant as individual item with linking properties
    metafieldVariants.forEach((variant) => {
      cartItems.push({
        id: variant.id,
        quantity: 1,
        properties: buildChildProductProperties(bundleId, mainProductTitle)
      });
    });



    // Check if professional assembly is selected from visible section (desktop or mobile)
    const desktopAssemblyContainer = document.querySelector('.info-desktop .add-cart-main-assembly');
    const mobileAssemblyContainer = document.querySelector('.info-mobile .add-cart-main-assembly');

    // Determine which assembly container to use based on visibility
    let assemblyContainer = null;
    if (desktopAssemblyContainer && window.getComputedStyle(desktopAssemblyContainer.closest('.info-desktop')).display !== 'none') {
      assemblyContainer = desktopAssemblyContainer;
    } else if (mobileAssemblyContainer && window.getComputedStyle(mobileAssemblyContainer.closest('.info-mobile')).display !== 'none') {
      assemblyContainer = mobileAssemblyContainer;
    }

    if (assemblyContainer && assemblyContainer.classList.contains('assembly-added')) {
      const assemblyBtn = assemblyContainer.querySelector('.btn-assembly-cart');
      const postcodeInput = assemblyContainer.querySelector('.assembly-postcode-value');
      if (assemblyBtn) {
        const assemblyVariantId = parseInt(assemblyBtn.getAttribute('data-id'));
        if (!isNaN(assemblyVariantId)) {
          // Build properties with postcode
          const assemblyProperties = buildChildProductProperties(bundleId, mainProductTitle);
          if (postcodeInput && postcodeInput.value) {
            assemblyProperties['Postcode'] = postcodeInput.value;
          }
          cartItems.push({
            id: assemblyVariantId,
            quantity: 1,
            properties: assemblyProperties
          });
        }
      }
    }


    if($('.mattress-add-on.selected input').val() != undefined){
      const mattressVariantId = parseInt($('.mattress-add-on.selected input').val());
      if (!isNaN(mattressVariantId)) {
        cartItems.push({
          id: mattressVariantId,
          quantity: 1,
          properties: buildChildProductProperties(bundleId, mainProductTitle)
        });
      }
    }


    // Disable button and show loading state
    addToCartBtn.classList.add('loading');
    addToCartBtn.textContent = 'Adding...';
    addToCartBtn.style.pointerEvents = 'none';

    try {
      await addToCart(cartItems);

      // Success - redirect to cart
      window.location.href = '/cart';

    } catch (error) {
      console.error('Add to cart error:', error);
      showError(error.message || 'Failed to add to cart. Please try again.');

      // Re-enable button
      addToCartBtn.classList.remove('loading');
      addToCartBtn.textContent = 'ADD TO CART';
      addToCartBtn.style.pointerEvents = 'auto';
    }
  }

  // Initialize
  function init() {
    // Check if variant data loaded
    const variantsData = getProductVariantsData();
    if (variantsData.variants.length === 0) {
      console.warn('No product variants data found');
    }

    // Set up tab click handlers
    const tabs = document.querySelectorAll('.variant-items-list-custom li');
    tabs.forEach((tab) => {
      tab.addEventListener('click', handleTabClick);
    });

    // Set up variant change handlers
    const variantList = document.querySelector('.custom-variant-list');
    if (variantList) {
      variantList.addEventListener('change', handleVariantChange);
    }

    // Set up Add to Cart button handler
    const addToCartBtn = document.querySelector('.variant-cart-add-btn');
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', handleAddToCart);
    }

    // Set up professional assembly button handlers for both desktop and mobile sections
    initAssemblyPostcodeModal();

    // Initial price calculation - add small delay to ensure DOM is ready
    setTimeout(() => {
      updateVariantPrices();
    }, 100);
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }


  // if mobile screen 
  function handleResize() {
    const isMobile = window.innerWidth <= 768;

    // .variant-items-list-custom li each check and click to activate first tab on mobile but not on .color-tab 
    const variantTabs = document.querySelectorAll('.variant-items-list-custom li');
    if (isMobile) {
      let firstActivated = false;
      variantTabs.forEach(function (tab) {
        if (!tab.classList.contains('color-tab') && !firstActivated) {
          tab.classList.add('active');
          const targetId = tab.getAttribute('data-id');
          // show target tab content
          const targetContent = document.getElementById(targetId);
          if (targetContent) {
            targetContent.classList.add('active');
          }
          firstActivated = true;
        } else {
          tab.classList.remove('active');
          const targetId = tab.getAttribute('data-id');
          // hide target tab content
          const targetContent = document.getElementById(targetId);
          if (targetContent) {
            targetContent.classList.remove('active');
          }
        }
      });
    }

  }

  window.addEventListener('resize', handleResize);
  // Initial check
  handleResize();





  // Handle open buttons
  const openButtons = document.querySelectorAll('[data-dilog]');

  openButtons.forEach(btn => {
    btn.addEventListener('click', function () {
      const popupId = this.getAttribute('data-dilog');
      const popup = document.getElementById(popupId);

      if (popup) {
        popup.classList.add('open');
        document.body.classList.add('mattress-overlay-open');
      }
    });
  });

  // Handle close buttons for all popups
  document.addEventListener('click', function (e) {
    if (e.target.closest('.close-side-model')) {
      const popup = e.target.closest('.side-model-mattress');

      if (popup) {
        popup.classList.remove('open');
        document.body.classList.remove('mattress-overlay-open');
      }
    }
  });


  // .content-sm-mattress .mattress-options-list li click event
  document.querySelectorAll('.content-sm-mattress .mattress-options-list li').forEach(function (tab) {
    tab.addEventListener('click', function () {
      // Remove active class from all tabs
      document.querySelectorAll('.content-sm-mattress .mattress-options-list li').forEach(function (t) {
        t.classList.remove('active');
      });

      // Add active class to clicked tab
      this.classList.add('active');

      // Show corresponding mattress list
      var selectedId = this.getAttribute('data-id');
      document.querySelectorAll('.mattress-list-ss').forEach(function (list) {
        if (list.id === selectedId) {
          list.classList.add('show');
        } else {
          list.classList.remove('show');
        }
      });
    });
  });

  $('.btn-mattress-cart').on('click', function () {
    const InfoHtml = $('.mattress-list-ss input[type="radio"]:checked').parent().html();
    $('.mattress-add-on.selected').html(InfoHtml).show();
    $('.mattress-add-on.selection').hide();
    $('.side-model-mattress').removeClass('open');
    document.body.classList.remove('mattress-overlay-open');
  });


  
  $(document).on('click','.mattress-add-on.selected a.remove-selection', function () {
    $('.mattress-add-on.selected').hide().html('');
    $('.mattress-add-on.selection').show();

  });

  // ==============================
  // Professional Assembly Postcode Modal
  // ==============================

  function initAssemblyPostcodeModal() {
    const modal = document.getElementById('assembly-postcode-modal');
    console.log('initAssemblyPostcodeModal called, modal found:', !!modal);
    if (!modal) return;

    const postcodeSelect = document.getElementById('postcode-select');
    const postcodeSearch = document.getElementById('postcode-search');
    const confirmBtn = modal.querySelector('.btn-postcode-confirm');
    const cancelBtn = modal.querySelector('.btn-postcode-cancel');
    const closeBtn = modal.querySelector('.assembly-postcode-modal-close');
    const notFoundMsg = modal.querySelector('.postcode-not-found-msg');

    // Populate the postcode select dropdown
    populatePostcodeSelect(postcodeSelect, ALLOWED_POSTCODES);

    // Set up assembly button handlers
    const assemblyContainers = document.querySelectorAll('.add-cart-main-assembly');
    console.log('Assembly containers found:', assemblyContainers.length);

    assemblyContainers.forEach(function (container) {
      const addBtn = container.querySelector('.btn-assembly-cart');
      const removeBtn = container.querySelector('.btn-assembly-remove');

      if (addBtn) {
        console.log('Adding click handler to assembly button');
        addBtn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          console.log('Assembly Add button clicked!');
          currentAssemblyContainer = container;
          openPostcodeModal();
        });
      }

      if (removeBtn) {
        removeBtn.addEventListener('click', function () {
          container.classList.remove('assembly-added');
          // Clear the stored postcode
          const postcodeInput = container.querySelector('.assembly-postcode-value');
          if (postcodeInput) {
            postcodeInput.value = '';
          }
        });
      }
    });

    // Search functionality
    postcodeSearch.addEventListener('input', function () {
      const searchTerm = this.value.toUpperCase().trim();
      filterPostcodes(postcodeSelect, searchTerm, notFoundMsg);
    });

    // Select change handler
    postcodeSelect.addEventListener('change', function () {
      confirmBtn.disabled = !this.value;
    });

    // Double-click to select and confirm
    postcodeSelect.addEventListener('dblclick', function () {
      if (this.value) {
        confirmPostcode();
      }
    });

    // Confirm button
    confirmBtn.addEventListener('click', confirmPostcode);

    // Cancel button
    cancelBtn.addEventListener('click', closePostcodeModal);

    // Close button (X)
    closeBtn.addEventListener('click', closePostcodeModal);

    // Close on overlay click
    modal.addEventListener('click', function (e) {
      if (e.target === modal) {
        closePostcodeModal();
      }
    });

    // Close on Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('open')) {
        closePostcodeModal();
      }
    });
  }

  function populatePostcodeSelect(selectElement, postcodes) {
    // Clear existing options except the first placeholder
    selectElement.innerHTML = '<option value="">-- Select Postcode --</option>';

    postcodes.forEach(function (postcode) {
      const option = document.createElement('option');
      option.value = postcode;
      option.textContent = postcode;
      selectElement.appendChild(option);
    });
  }

  function filterPostcodes(selectElement, searchTerm, notFoundMsg) {
    const options = selectElement.querySelectorAll('option');
    let hasVisibleOptions = false;

    options.forEach(function (option) {
      if (!option.value) {
        // Keep the placeholder visible
        option.style.display = '';
        return;
      }

      if (option.value.toUpperCase().startsWith(searchTerm) || searchTerm === '') {
        option.style.display = '';
        hasVisibleOptions = true;
      } else {
        option.style.display = 'none';
      }
    });

    // Show/hide not found message
    if (searchTerm && !hasVisibleOptions) {
      notFoundMsg.style.display = 'block';
    } else {
      notFoundMsg.style.display = 'none';
    }

    // Reset selection if current selection is hidden
    if (selectElement.selectedOptions[0] && selectElement.selectedOptions[0].style.display === 'none') {
      selectElement.value = '';
      document.querySelector('.btn-postcode-confirm').disabled = true;
    }
  }

  function openPostcodeModal() {
    console.log('openPostcodeModal called');
    const modal = document.getElementById('assembly-postcode-modal');
    console.log('Modal element:', modal);

    if (!modal) {
      console.error('Modal not found!');
      return;
    }

    const postcodeSearch = document.getElementById('postcode-search');
    const postcodeSelect = document.getElementById('postcode-select');
    const confirmBtn = modal.querySelector('.btn-postcode-confirm');
    const notFoundMsg = modal.querySelector('.postcode-not-found-msg');

    // Reset modal state
    postcodeSearch.value = '';
    postcodeSelect.value = '';
    confirmBtn.disabled = true;
    notFoundMsg.style.display = 'none';

    // Reset all options visibility
    const options = postcodeSelect.querySelectorAll('option');
    options.forEach(function (option) {
      option.style.display = '';
    });

    // Open modal
    console.log('Adding open class to modal');
    modal.classList.add('open');
    document.body.classList.add('assembly-modal-open');
    console.log('Modal classes after open:', modal.className);

    // Focus search input
    setTimeout(function () {
      postcodeSearch.focus();
    }, 100);
  }

  function closePostcodeModal() {
    const modal = document.getElementById('assembly-postcode-modal');
    modal.classList.remove('open');
    document.body.classList.remove('assembly-modal-open');
    currentAssemblyContainer = null;
  }

  function confirmPostcode() {
    const postcodeSelect = document.getElementById('postcode-select');
    const selectedPostcode = postcodeSelect.value;

    if (!selectedPostcode || !currentAssemblyContainer) return;

    // Store the selected postcode in the hidden input
    const postcodeInput = currentAssemblyContainer.querySelector('.assembly-postcode-value');
    if (postcodeInput) {
      postcodeInput.value = selectedPostcode;
    }

    // Add the assembly-added class to show it's selected
    currentAssemblyContainer.classList.add('assembly-added');

    // Close the modal
    closePostcodeModal();
  }
// ==============================
  // Fabric Color Sync & Mobile Trigger
  // ==============================
  document.addEventListener('change', function(e) {
    if (e.target.name === 'variant-fabric-color') {
      const variantId = e.target.value;
      const colorName = e.target.getAttribute('data-color-name');

      // 1. Remove the active class from ALL fabric labels
      document.querySelectorAll('input[name="variant-fabric-color"]').forEach(input => {
        const label = input.closest('.custom-variant-item');
        if (label) label.classList.remove('active');
      });

      // 2. Sync inputs and add the active class to the selected ones
      document.querySelectorAll(`input[name="variant-fabric-color"][value="${variantId}"]`).forEach(input => {
        input.checked = true;
        const label = input.closest('.custom-variant-item');
        if (label) label.classList.add('active');
      });

      // Update the text label on mobile
      const mobileLabel = document.getElementById('mobile-selected-color-name');
      if (mobileLabel) {
        mobileLabel.textContent = colorName;
      }

      // Trigger your theme's native price updates
      updateVariantPrices();
      
      const colorTab = document.getElementById('tab-option-color-1');
      if (colorTab) clearTabError(colorTab);
    }
  });
// ==============================
  // Dynamic Mattress Size Syncing
  // ==============================
  function handleizeText(str) {
    if (!str) return '';
    return str.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/(^-|-$)/g, '');
  }

  function syncMattressSizes() {
    const sizeInput = document.querySelector('input[name="variant-option-size"]:checked');
    if (!sizeInput) return;

    const selectedBedSize = sizeInput.getAttribute('data-option-value');
    const sizeHandle = handleizeText(selectedBedSize);
    const mattressItems = document.querySelectorAll('.dynamic-mattress-item');

    mattressItems.forEach(item => {
      const input = item.querySelector('.dynamic-mattress-input');
      const priceDisplay = item.querySelector('.mattress-price');
      const variantId = item.getAttribute(`data-id-${sizeHandle}`);
      const variantPrice = item.getAttribute(`data-price-${sizeHandle}`);

      if (variantId && variantPrice) {
        item.style.display = 'block'; 
        
        input.value = variantId;
        input.setAttribute('value', variantId);
        input.setAttribute('data-price', variantPrice);
        
        priceDisplay.textContent = formatPrice(parseInt(variantPrice));
      } else {
        item.style.display = 'none';
        if (input.checked) {
          input.checked = false;
          const removeBtn = document.querySelector('.mattress-add-on.selected a.remove-selection');
          if (removeBtn) removeBtn.click();
        }
      }
    });

    // Update ALL instances (Desktop + Mobile) if user changes bed size after picking a mattress
    const checkedMattress = document.querySelector('.dynamic-mattress-input:checked');
    const selectedContainers = document.querySelectorAll('.mattress-add-on.selected');
    
    if (checkedMattress && selectedContainers.length > 0) {
       const infoHtml = checkedMattress.closest('.dynamic-mattress-item').innerHTML;
       
       selectedContainers.forEach(container => {
           if (container.style.display !== 'none') {
               container.innerHTML = infoHtml;
               const copiedInput = container.querySelector('input');
               if (copiedInput) {
                  copiedInput.value = checkedMattress.value;
                  copiedInput.setAttribute('value', checkedMattress.value);
                  copiedInput.setAttribute('data-price', checkedMattress.getAttribute('data-price'));
               }
           }
       });
       if (typeof updateVariantPrices === 'function') updateVariantPrices(); 
    }
  }

  document.addEventListener('DOMContentLoaded', syncMattressSizes);
  document.addEventListener('change', function(e) {
    if (e.target.name === 'variant-option-size') {
      syncMattressSizes();
    }
  });

  // ==============================
  // Mattress Popup 'Add to Basket' Fix
  // ==============================
  const addMattressBtn = document.querySelector('.btn-mattress-cart');
  
  if (addMattressBtn) {
    const newBtn = addMattressBtn.cloneNode(true);
    addMattressBtn.parentNode.replaceChild(newBtn, addMattressBtn);
    
    newBtn.addEventListener('click', function(e) {
      e.preventDefault();
      const checkedInput = document.querySelector('.dynamic-mattress-input:checked');
      
      if (checkedInput) {
        const infoHtml = checkedInput.closest('.dynamic-mattress-item').innerHTML;
        
        // Find ALL instances (Desktop + Mobile)
        const selectedContainers = document.querySelectorAll('.mattress-add-on.selected');
        const selectionContainers = document.querySelectorAll('.mattress-add-on.selection');
        
        selectedContainers.forEach(container => {
          container.innerHTML = infoHtml;
          
          const copiedInput = container.querySelector('input');
          if (copiedInput) {
             copiedInput.value = checkedInput.value;
             copiedInput.setAttribute('value', checkedInput.value);
             copiedInput.setAttribute('data-price', checkedInput.getAttribute('data-price'));
          }
          container.style.display = 'flex'; // Show selected mattress
        });

        selectionContainers.forEach(container => {
          container.style.display = 'none'; // Hide "Choose Mattress" button
        });
        
        if (typeof updateVariantPrices === 'function') updateVariantPrices();
      }
      
      const popup = document.getElementById('mattress-pop');
      if (popup) popup.classList.remove('open');
      document.body.classList.remove('mattress-overlay-open');
      const overlay = document.getElementById('dividebuy-popup-overlay');
      if (overlay) overlay.classList.remove('show');
    });
  }
  
  // Update "Remove" button to work on both Desktop and Mobile!
  document.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('remove-selection')) {
       e.preventDefault();
       
       document.querySelectorAll('.mattress-add-on.selected').forEach(el => {
         el.style.display = 'none';
         el.innerHTML = '';
       });
       
       document.querySelectorAll('.mattress-add-on.selection').forEach(el => {
         el.style.display = ''; // Restore default display
       });
       
       setTimeout(() => {
         if (typeof updateVariantPrices === 'function') updateVariantPrices();
       }, 50);
    }
  });
  
  // Also ensure the "Remove" button updates the price!
  document.addEventListener('click', function(e) {
    if (e.target && e.target.classList.contains('remove-selection')) {
       setTimeout(() => {
         if (typeof updateVariantPrices === 'function') updateVariantPrices();
       }, 50);
    }
  });
// ==============================
  // Mobile Metafield Syncing (Colour 1, Colour 2, etc.)
  // ==============================
  document.addEventListener('change', function(e) {
    if (e.target.name && e.target.name.startsWith('mobile-variant-')) {
      const desktopTargetId = e.target.getAttribute('data-desktop-target');
      const colorName = e.target.getAttribute('data-color-name');
      const handle = e.target.name.replace('mobile-variant-', '');
      
      // 1. Visually update the active styling on the mobile swatches
      document.querySelectorAll(`input[name="${e.target.name}"]`).forEach(input => {
        const label = input.closest('.custom-variant-item');
        if (label) label.classList.remove('active');
      });
      
      const activeLabel = e.target.closest('.custom-variant-item');
      if (activeLabel) activeLabel.classList.add('active');

      // 2. Update the "Select an option" text label
      const nameSpan = document.getElementById(`mobile-selected-${handle}`);
      if (nameSpan) nameSpan.textContent = colorName;

      // 3. Trigger the hidden desktop input so prices and cart data update seamlessly
      const desktopInput = document.getElementById(desktopTargetId);
      if (desktopInput) {
        desktopInput.checked = true;
        if (typeof updateVariantPrices === 'function') updateVariantPrices();
      }
    }
  });

})();

